<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>

      <!-- //header -->
      <Header title="Slide" />

      <div id="container" ref="container">
        <section id="contents">
          <div class="shareWrap">
            <div class="shareView">
              <div class="swiper-container" ref="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-bind:key="item.id" v-for="item in items">
                    <img :src="item.url" alt />
                  </div>
                </div>
              </div>

              <div class="btnWrap">
                <a href="#" class="reflash" :style="automodeStyle" @click.prevent="automode">
                  <img src="@/assets/img/reflash2.png" alt="새로고침" />
                </a>
                <a href="#" class="prev swiper-prev" ref="swiper-pref">
                  <img src="@/assets/img/prev.png" alt="이전" />
                </a>
                <a href="#" class="next swiper-next" ref="swiper-next">
                  <img src="@/assets/img/next.png" alt="다음" />
                </a>
              </div>
            </div>
            <!-- shareView -->
          </div>
          <!-- shareWrap -->
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>


<script>
import Header from "@/components/SubHeader";
import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
  components: { Header },
  mounted() {
    let $this = this;
    let itemid = this.$route.params.itemid;
    this.$axios
      .get(`${process.env.VUE_APP_REST_SERVER}/api/v1/item/${itemid}`)
      .then(resp => {
        let items = JSON.parse(resp.data.jimun_multi);

        $this.items = items;
      })
      .then(() => {
        this.swiper = new Swiper(".swiper-container", {
          navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev"
          }
        });
      });
  },
  created() {
    this.$store.dispatch("initslide");
  },
  data() {
    return {
      items: [],
      swiper: null
    };
  },
  computed: {
    automodeStyle() {
      return this.$store.state.slide.automode
        ? "background:crimson;"
        : "background:#272727";
    },
    slidego() {
      return this.$store.state.slide.index;
    }
  },
  watch: {
    slidego(val) {
      if (this.$store.state.slide.automode) {
        this.swiper.slideTo(val);
      }
    }
  },
  methods: {
    automode() {
      this.$store.state.slide.automode = !this.$store.state.slide.automode;
    }
  }
};
</script>


<style lang="scss" scoped>
.shareWrap {
  min-height: 100vh;
  background: #282829;
  padding: 55px 0% 0;
}
.shareList {
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}
.shareList li {
}
.shareList li .dt {
  padding: 20px 0% 20px;
  font-size: 0;
  border-bottom: 1px solid rgba(107, 107, 107, 0.3);
}
.shareList li .dt > div {
  display: inline-block;
  vertical-align: middle;
}
.shareList li .dt .num {
  width: 15%;
  color: rgba(255, 255, 255, 0.2);
  font-size: 16px;
  text-align: center;
}
.shareList li .dt .title {
  width: 60%;
  color: #ffffff;
  font-size: 14px;
}
.shareList li .dt .apply {
  width: 25%;
}
.shareList li.noApply .dt .apply {
  opacity: 0.5;
}
.shareList li .dt .apply a {
  color: #ffffff;
  font-size: 10px;
  text-align: center;
  display: block;
}
.shareList li .dt .apply a img {
  width: 22%;
  display: block;
  margin: 0 auto 5px;
}
.shareList li .dt .apply .arrow {
  width: 12px;
  margin: 10px auto 0;
  display: block;
}

.shareList li .dd {
  padding: 10px 5% 10px 15%;
  border-bottom: 1px solid rgba(107, 107, 107, 0.3);
  background: #6a6f75;
  box-shadow: black 5px 5px 15px -10px inset;
  font-size: 0;
}
.shareList li .dd p {
  color: #ffffff;
  font-size: 12px;
  font-family: "NotoKrL";
  font-weight: 100;
}
.shareList li .dd .inputWrap {
  margin-top: 10px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}
.shareList li .dd .inputWrap input {
  height: 30px;
  border-radius: 5px;
  background: #ffffff;
  border: none;
  padding: 0 10px;
}
.shareList li .dd .inputWrap input.mail1 {
  width: 20%;
}
.shareList li .dd .inputWrap input.mail2 {
  width: 50%;
}
.shareList li .dd .inputWrap a {
  height: 30px;
  line-height: 30px;
  text-align: center;
  width: 20%;
  background: #58af70;
  border-radius: 5px;
  display: inline-block;
  vertical-align: top;
  color: #fff;
  font-size: 13px;
  margin-left: 1%;
}

.shareView {
  background: #000;
  display: block;
  position: relative;
  height: calc(100vh - 105px);
}
.shareView .swiper-container {
  width: 100%;
}
.shareView .swiper-slide {
  height: calc(100vh - 105px);
  line-height: calc(100vh - 105px);
}
.shareView .swiper-slide img {
  width: 100%;
}
.shareView .btnWrap {
  font-size: 0;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;

  z-index: 10000;
}
.shareView .btnWrap a {
  width: 33.33%;
  display: inline-block;
  vertical-align: top;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background: #1b1b1b;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}
.shareView .btnWrap a img {
  width: 12.5px;
  margin-top: -5px;
}
.shareView .btnWrap a.reflash {
  background: #272727;
}
.shareView .btnWrap a.reflash img {
  width: 25px;
}
</style>